import { BaseModal } from 'layout'

export default function ModalVistoDocumento(props) {
  const {
    documentoInput,
    propsEntita,
    chiudiModifica,
    documentoCongelato,
    VistoDocumento,
  } = props

  return (
    <BaseModal
      titolo='"Visto" sul documento'
      open={true}
      onClose={chiudiModifica}
      contenutoNonCentrato
      maxWidth='md'
      disabilitaChiusuraCliccandoFuori
      nascondiBottoneChiudi
    >
      <VistoDocumento
        documentoInput={documentoInput}
        pathDocumento={propsEntita.pathEntita}
        documentoCongelato={documentoCongelato}
        chiudiModifica={chiudiModifica}
      />
    </BaseModal>
  )
}